import classNames from 'classnames/bind'

import styles from './style.module.scss'
import { useBannerList } from '../../Live/components/Banner/hooks/useBannerList'
import { BANNER_LOCATION } from '@/constants/banner'
import ImageComponent from '@/components/common/Image'
import Link from 'next/link'
import useMedia from '@/hooks/useMedia'
import { safeUrl } from '@/methods/url/safeUrl'

const cx = classNames.bind(styles)

const HomeMiddleBanner = () => {
  const { isDesktop, isMobile } = useMedia()
  const { bannerList } = useBannerList({
    location: isDesktop ? BANNER_LOCATION.SHOP_EVENT_HOME : BANNER_LOCATION.SHOP_EVENT_HOME,
    cache: 0,
  })
  const bannerUrl = bannerList?.data?.[0]?.imgUrl ?? ''

  if (!bannerUrl) return null

  return (
    <div className={cx('home-middle-banner')}>
      <Link href={safeUrl(bannerList?.data?.[0]?.imgLink)} target='_blank'>
        <ImageComponent
          src={bannerUrl}
          alt='banner'
          width={1440}
          height={200}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: isMobile ? '0' : '10px',
          }}
        />
      </Link>
    </div>
  )
}

export default HomeMiddleBanner
